import React, { useEffect, useState } from "react";
import {MultiSelect} from '../MultiSelect'
import { BASE_URL, NODE_API_URL } from "../../../../../env_config";
import axios from "axios";
import Cookies from "js-cookie";
// import { Field } from "formik";
// import { toAbsoluteUrl } from "../../../../_helpers";
// import SVG from "react-inlinesvg";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import PropTypes from "prop-types";
// import { at } from "lodash";
// import { useField } from "formik";

export const Shape = ({ language ,formik,errorMsg,setErrorMsg}) => {

    const [shapeNames,setShapeName] = useState([]);
        useEffect(() => {
            axios({
                method: "get",
                url: process.env.REACT_APP_ENV === "production"?`https://api.oasis.diamondsoncall.online/admin/getShapes`:`https://api.immitation.diamondsupload.com/admin/getShapes`,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
                }
            })
                .then(function (res) {
                    if (res && res.data.success && res.data.data) {
                        setShapeName(res.data.data)
                    }
                })
                .catch(function (res) {
                    if (res?.response?.data?.message === "UnAuthorized!") {
                        var cookies = document.cookie.split(";");
                        for (var i = 0; i < cookies.length; i++) {
                            if (cookies[i] && !cookies[i].includes("view")) {
                                var equals = cookies[i].indexOf("=");
                                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                            }
                        }
                        window.location.replace(`${BASE_URL}/logout`);
                    }
                });
        }, []);

    const ShapeData = shapeNames.map((value, index) => ({
        id: index + 1,
        value
    }));
    return (
        <>
            
            <div className="row mt-5 pb-10 border-bottom">
                <div className="col-lg-12">
                    <p className="font-weight-bold mb-0">
                        {language.SHAPE_SHAPE}
                    </p>
                </div>
                <div className="col-lg-12 flex-wrap d-flex">
                    <MultiSelect errorMsg={errorMsg} setErrorMsg={setErrorMsg} language={language} options={ShapeData} label={"Select Shape"} name={"Shape"} formik={formik}/>
                </div>
            </div>
            {/* <div className="row mt-5 pb-10 border-bottom">
                <div className="col-lg-12">
                    <p className="font-weight-bold mb-2">
                        {language.SHAPE_SHAPE}
                    </p>
                </div>
                <div className="col-lg-12 flex-wrap d-flex">
                    {ShapeData.map((item) => (
                        <label
                            key={item.id}
                            className="search_btn_check iframe_setup"
                        >
                            <Field
                                type="checkbox"
                                name="Shape"
                                id={`${item.shape}_shape`}
                                value={item.value}
                            />
                            <div className="labBox selectBox ">
                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id="tooltip">
                                            {item.shape}
                                        </Tooltip>
                                    }
                                >
                                    <span className="text-uppercase text-truncate">
                                        {item.shape}
                                    </span>
                                </OverlayTrigger>
                            </div>
                        </label>
                    ))}
                </div>
            </div> */}
        </>
    );
};
